<template>
  <div class="row">
    <div class=" col-lg-4 col-xl-3" v-for="(loop , key) in 10" :key="key">
      <div class="favourite-container mx-auto ml-md-auto">
        <div class="d-flex">

        
        <div>
          <div class="fav-img">
            <img src="@/assets/img/fav.png" class="img-fluid">
            <div class="status">5 Screenig</div>
          </div>
          <div class="movie-title">Justice League</div>
          <div class="movie-info">
            <span>PG-13</span>
            <span>|</span>
            <span>2018</span>
          </div>
        </div>

        <div>
          <form>
            <input type="checkbox" class="d-none" id="favourite">
            <label for="favourite"></label>
          </form>
        </div>
      </div>
      </div>


    </div>
  </div>
</template>

<script>
  export default {

  }

</script>

<style>
  .favourite-container {
    display: table;
    margin-bottom: 80px;
  }

  .favourite-container .fav-img {
    display: table;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
  }

  .fav-img .status {
    bottom: 0;
    width: 100%;
    display: flex;
    height: 35px;
    color: #fff;
    font-size: 14px;
    position: absolute;
    text-align: center;
    align-items: center;
    justify-content: center;
    /* col-6 col-md-6 */
    background-color: #E70D01;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .favourite-container .movie-title {
    font-weight: 600;
    margin-top: 10px;
    text-align: center;
  }

  .favourite-container .movie-info {
    font-size: 14px;
    text-align: center;
  }


  .favourite-container label{
    width: 25px;
    height: 25px;
    margin-top: 15px;
    margin-left: 10px;
    user-select: none;
    background: url('../../assets/img/svg/icon-favourite-empty.svg') center center no-repeat;
    background-size: contain;
  }

  .favourite-container input[type="checkbox"]:checked + label{
    background: url('../../assets/img/svg/icon-favourite-filled.svg') center center no-repeat;
    background-size: cover;
  }


</style>



// WEBPACK FOOTER //
// src/components/pages/myFavourites.vue